import PropTypes from 'prop-types';

import styles from './MobileReferenceSection.module.scss';

/**
 * 모바일 참조자/시행자/참조문서 섹션 컴포넌트
 */
function MobileReferenceSection({
  recipients,
  executors,
  referenceDocuments,
  onReferenceDocClick,
}) {
  const hasRecipients = recipients && recipients.length > 0;
  const hasExecutors = executors && executors.length > 0;
  const hasReferenceDocs = referenceDocuments && referenceDocuments.length > 0;

  if (!hasRecipients && !hasExecutors && !hasReferenceDocs) {
    return null;
  }

  return (
    <div className={styles.container}>
      {/* 참조자 */}
      {hasRecipients && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>참조자</h4>
          <div className={styles.tagList}>
            {recipients.map(function (recipient, index) {
              const name = typeof recipient === 'string' ? recipient : recipient.name;
              return (
                <span key={`recipient-${index}`} className={styles.tag}>
                  {name}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* 시행자 */}
      {hasExecutors && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>시행자</h4>
          <div className={styles.tagList}>
            {executors.map(function (executor, index) {
              const name = typeof executor === 'string' ? executor : executor.name;
              return (
                <span key={`executor-${index}`} className={styles.tag}>
                  {name}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* 참조문서 */}
      {hasReferenceDocs && (
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>참조문서</h4>
          <div className={styles.docList}>
            {referenceDocuments.map(function (doc, index) {
              return (
                <button
                  key={`ref-doc-${index}`}
                  type="button"
                  className={styles.docItem}
                  onClick={function () {
                    if (onReferenceDocClick) {
                      onReferenceDocClick(doc.idx || doc.id);
                    }
                  }}
                >
                  <span className={styles.docTitle}>{doc.title || doc.name || '제목 없음'}</span>
                  <span className={styles.docArrow}>›</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

MobileReferenceSection.propTypes = {
  recipients: PropTypes.array,
  executors: PropTypes.array,
  referenceDocuments: PropTypes.array,
  onReferenceDocClick: PropTypes.func,
};

MobileReferenceSection.defaultProps = {
  recipients: [],
  executors: [],
  referenceDocuments: [],
  onReferenceDocClick: null,
};

export default MobileReferenceSection;
